import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { IonIcon } from '@ionic/vue'
import * as icons from 'ionicons/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'IonicIcon',
  props: {
  icon: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'primary'
  },
  size: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonIcon), {
    icon: icons[props.icon],
    color: props.color,
    size: __props.size
  }, null, 8, ["icon", "color", "size"]))
}
}

})